export default {
  header_main: 'Receive / Reject Specimen',
  patient_info: 'Patient Information',
  receiveLab: 'Receive Specimen',
  rejectLab: 'Reject Specimen',
  printOrderReport: 'Request Form',
  printSticker: 'Specimen Barcode',
  Laboratory: 'Laboratory',
  OrderItemId: 'Test Item ID',
  OrderItemDesc: 'Test Item Name',
  cust_name: 'Customer',
  OrderItemLaboratoryName: 'Laboratory Department',
  OrderId: 'Lab No.',
  IdCard: 'ID Card',
  OrderItemSpecimenType: 'Specimen Type',
  OrderItemPrice: 'Price (Baht)',
  is_get_back: 'Request Sample Return',
  OrderItemUrgent: 'Urgent Result',
  lab_item_status: 'Status',
  lis_sid: 'Specimen ID',
  OrderItemRemark: 'Remark',
  PackageNo: 'Package No.',
  PatientName: 'Patient Name',
  HN: 'HN',
  prefix: 'Prefix',
  fullname: 'Patient Name',
  firstname: 'First Name',
  lastname: 'Last Name',
  birthday: 'Birth Date',
  age: 'Age',
  sex: 'Sex',
  user_created: 'Requested By',
  date_created: 'Requested Date',
  date_send: 'Sent Date',
  date_receive: 'Received Date',
  date_result: 'Reported Date',
  collectionDate: 'Collection Date',
  status: 'Status',
  hospitalLabNo: 'Hospital Lab No.',
  paymentType: 'Payment Type',
  project: 'Project',
  download: 'Report',
  userDownload: 'Downloaded By',
  statusObj: {
    OP: 'Requested',
    COLLECTION: 'Collection',
    RECEIVEDALL: 'Received',
    FIRSTAPPROVE: 'Reported',
    LASTAPPROVE: 'Approved',
    CA: 'Cancelled',
    labApprove: 'Released',
    labNotApprove: 'Pending',
    labApprove2: 'Approved',
    labNotApprove2: 'Reported'
  },
  errorMissingResult: 'Please report the result first.',
  Previous: 'Previous',
  Approve: 'Send Report',
  next: 'Next',
  approveNext: 'Send & Continue',
  ChkApprove: 'Laboratory Report',
  user_approve: 'Approved By',
  labResult: 'Lab Results',
  upload: 'Attachment',
  facility: 'Facility',
  labNo: 'Lab No.',
  patientName: 'Patient Name',
  patientID: 'Patient ID',
  hn: 'HN',
  remainingTAT: 'Remaining TAT',
  sampleID: 'Sample ID',
  result: 'Result',
  viewDetail: 'View Detail',
  sendToNTIP: 'Send to NTIP',
  headerTitle: 'Results Management',
  receivedDate: 'Received Date',
  registerDate: 'Registration Date',
  back: 'Back',
  save: 'Save',
  prinLabResult: 'Print Report',
  cancelApprove: 'Cancel Approve',
  report: 'Report',
  approve: 'Approve',
  firstApprove: 'Reported',
  secondApprove: 'Approved',
  result_item_discription: 'Result Item Description',
  result_value: 'Result Value',
  repeat: 'Repeat',
  flag: 'Flag',
  rejectHis: 'Reject History',
  is_reject: 'Reject',
  rejectDate: 'Reject Date',
  rejectLocation: 'Reject Location',
  rejectUser: 'Reported By',
  rejectNotifier: 'Notified By',
  rejectType: 'Reject Type',
  rejectReason: 'Reject Reason',
  date_speciment_receieve: 'Specimen Received Date',
  resultValue: 'Result',
  dateTimeCreated: 'Created Date/Time',
  resultType: 'Result Type',
  unit: 'Unit',
  sub_category_desc: 'Category/Section',
  test_item_desc: 'Test Item Description',
  labStatus: 'Lab Status',
  labApproveStatus: 'Reported',
  labApproveStatus2: 'Approved',
  resultHistory: 'Previous Result',
  approveHistory: 'Approval History',
  specimen_type_id: 'Specimen ID',
  order_id: 'Lab No.',
  probePathogen: 'Probe / Pathogen',
  probe: 'Probe(s)',
  pathogen: 'Pathogen(s)',
  lab_specimen_type: 'Specimen Type',
  reference: 'Reference',
  dateDownload: 'Download Date',
  recalAttb: 'Update Reference',
  errorMissingAgonistResult: 'Please complete all required information before proceeding.',
  addAgonist: 'Add Agonist',
  deleteAgonist: 'Delete Agonist',
  resultDesc: 'Result Item Description',
  enterPassword: 'Please enter password',
  diagnosis: 'Diagnosis',
  otherComment: 'Other Comments',
  comment: 'Comment',
  volumeUrine: 'Urine Volume (ml)',
  level_cd: 'Level',
  status_new: 'New Status',
  status_old: 'Old Status',
  employee_no: 'Employee No.',
  reason: 'Reason',
  confirmCancelApprove: 'Are you sure you want to cancel the result approval?',
  dateTime: 'Date - Time',
  request_by: 'Requesting Physician',
  no: 'No.',
  description: 'Description',
  shortcut: 'Shortcut',
  resultLab: 'Laboratory Report',
  password: 'Password',
  enterReason: 'Please specify the reason',
  cancal: 'Cancel',
  confirm: 'Confirm',
  pleaseSaveChangesBeforeSwitchingCategory: 'Please save changes before switching category',
  saveError: 'Save failed',
  agonistAlreadyAdded: 'Duplicate Order Item is not allowed',
  saveCommentSuccess: 'Comment saved successfully',
  pleaseInputCancelReason: 'Please specify the reason',
  errorSelectApprove: 'Please select an Order to approve',
  search: 'Search',
  itemHist: 'Item History',
  searchData: 'Search Data',
  pleaseSelectCategory: 'Please select data first'
}
